"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFeatureToggles = getFeatureToggles;
var _staticApiClientReact = require("@ori/static-api-client-react");
async function getFeatureToggles(apiClientOptions, tenant) {
  const apiClient = new _staticApiClientReact.ApiClient(apiClientOptions);
  return (0, _staticApiClientReact.getTenantFeatureToggles)(apiClient, tenant).then(({
    data
  }) => data.collection);
}
//# sourceMappingURL=getFeatureToggles.js.map